//
//
//
//
//
//
//
//

import amapLocation from "@/components/amap/amapLocation.vue"

export default {
  name: "test",
  components: {
    amapLocation
  },
  data() {
    return {
      location: {
        address: null
      }
    }
  },
  watch: {
    address(newValue, oldValue) {
    }
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/test.vue